import { map, split, upperCase } from 'lodash'
import Cookies from 'universal-cookie'
import moment from 'moment'
const SUBURBANJUNGLE_API_HOST = process.env.SUBURBANJUNGLE_API_HOST

export const getClientsApiEndpoint = () => {
  return `${SUBURBANJUNGLE_API_HOST}/clients/`
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export const createStringAvatar = (name) => {
  const names = split(name, ' ')
  const letters = map(names, (firstName) => upperCase(firstName.charAt(0)))
  return letters.join('').substring(0, 2)
}

export const convertTimeString = (time) => {
  if (time.indexOf(':') !== -1) {
    return moment(time, 'HH:mm').format('hh:mm a')
  }
  return time
}

export const getHostname = () => {
  return new URL(process.env.SUBURBAN_HOST).hostname
}

const getParentDomain = () => {
  const hostname = new URL(process.env.API_HOSTNAME).hostname
  const parts = hostname.split('.')
  if (parts.length > 1) {
    return '.' + parts.slice(-2).join('.')
  }
  return hostname
}

export const migrateCookies = () => {
  const cookies = new Cookies()
  const parentDomain = getParentDomain()
  const currentDomain = getHostname()

  if (parentDomain === currentDomain) return

  const auth = cookies.get('Authorization')
  const user = cookies.get('user')

  cookies.remove('Authorization', { path: '/', domain: parentDomain })
  cookies.remove('user', { path: '/', domain: parentDomain })

  if (auth) {
    let expires = new Date()
    expires.setMonth(expires.getMonth() + 2)
    expires = new Date(expires)
    cookies.set('Authorization', auth, { path: '/', expires, domain: currentDomain })
    cookies.set('user', user, { path: '/', expires, domain: currentDomain })
  }
}

export const logoutInvalidRequest = (error) => {
  const cookies = new Cookies()
  localStorage.clear()
  for (const cookie in cookies.getAll()) {
    cookies.remove(cookie, { path: '/', domain: getHostname() })
  }
  window.location.pathname = '/login'
  throw new Error(error)
}

export const capitalizeFirstLetter = (str) => {
  if (!str) return false;

  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const formatPriceRange = (priceRangeString) => {
  if (priceRangeString && priceRangeString.indexOf('-') > 0) {
    const [minString, maxString] = priceRangeString.split('-');
    const min = parseInt(minString.trim())
    const max = parseInt(maxString.trim())
    if (min == 0 && max == 0) {
      return '$0'
    } else if (max == 0) {
      return `$${min.toLocaleString()} +`;
    } else {
      return `$${min.toLocaleString()} - $${max.toLocaleString()}`;
    }
  }
  return ''
}
